<template>
  <svg
    :class="svgClass"
    :style="{ color, width, height }"
    aria-hidden="true"
  >
    <use :xlink:href="iconName" />
  </svg>

</template>

<script>
  export default {
    name: "SvgIcon",
    props: {
      name: {
        type: String,
        required: true
      },
      className: String,
      color: String,
      width: String,
      height: String
    },
    computed: {
      iconName() {
        return `#icon-${this.name}`
      },
      svgClass() {
        let className = this.className ? `icon-${this.className}` : "";
        return ["svg-icon", className];
      }
    }
  }
</script>

<style lang="less">
  .svg-icon {
    width: 18px;
    height: 18px;
    vertical-align: middle;
    fill: currentColor;
    overflow: hidden;
  }
</style>